import { DialogPanel, DialogTitle } from "@headlessui/react";
import LoadingWheel from "../LoadingWheel";

export default function MultiModalSection({ children, title, classes, onClick, isLoading }: { children: React.ReactNode, title?: string, classes?: string, onClick?: () => void, isLoading?: boolean}) {

  const size = classes?.includes("sm:max-w-") ? "" : "sm:max-w-lg";

  return (
    <DialogPanel onClick={onClick} className={`relative bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all ${size} sm:w-full sm:p-6 ${classes}`}>
      {title && <DialogTitle as="h3" className="text-lg font-medium leading-6 text-gray-900">{title}</DialogTitle>}
      
      {isLoading ? (<div className="flex justify-center items-center h-full w-full">
        <LoadingWheel />
      </div>) : ( <div className="mt-2">
        {children}
      </div>)}
      
    </DialogPanel>
  )
}